// Copyright (c) Facebook, Inc. and its affiliates.
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import InfiniteScroll from './components/scroll';

class App extends Component {
  render() {
    return (
      <InfiniteScroll dataPath={this.props.dataPath} />
    );
  }
}

const el = document.getElementById('root');
ReactDOM.render(<App dataPath={el.getAttribute('data-path')} />, el)
